<div class="asset-name" *ngIf="file">
  <div *ngIf="!editMode" title="{{ getDisplay(file.printName || file.displayName || file.name || file.title) }}">
    {{
      (file.printName || file.displayName || file.name || file.title).length > 30
        ? `${(file.printName || file.displayName || file.name || file.title).slice(0, 30)}...`
        : file.printName || file.displayName || file.name || file.title
    }}
  </div>
  <input *ngIf="editMode" [(ngModel)]="fileName" (blur)="saveName($event)" (keydown.enter)="saveName($event)" />
</div>
